import { Fragment } from "react";

import useLearnToSwimStaffDupPopup from "./UseLearnToSwimStaffDupPopup";

import ProviderStaffDupGrid from "../grids/ProviderStaffDupGrid";

import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import Constants from "@usas/ui-web/utils/Constants";

const LearnToSwimStaffDupPopup = ({ dupArrayData, newPersonObj, onPersonConfirmed, onCancelClicked }) => {
  const {
    isLoading,
    isSaving,
    dupGridState,
    newGridState,
    onContinueClicked,
    onSelectGridPerson
  } = useLearnToSwimStaffDupPopup(dupArrayData, newPersonObj, onPersonConfirmed)

  return (
    <Fragment>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={90}
        maxWidth={1020}
        title={"Staff Dupe Check"}
        displayPopUp={dupGridState.length > 0}
        onModalCanceled={onCancelClicked}>
        <p><b>Database Matches Found</b></p>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <ProviderStaffDupGrid
              actionLabel={'Use Existing Person'}
              persons={dupGridState}
              onSelected={onSelectGridPerson} />
          </div>
        </div>
        <p><b>Info Provided By User</b></p>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <ProviderStaffDupGrid
              actionLabel={'Create New Person'}
              persons={newGridState}
              onSelected={onSelectGridPerson} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onContinueClicked}>Continue</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </Fragment>
  );
};

export default LearnToSwimStaffDupPopup;